module.exports = "https://cdn.realtymogul.com/static/media/Elizabeth_B.99516f60.jpg";